import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { getCurrentDateFormatted } from "../../../../utilities/Utils";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalAudit = ({ showAudit, handleCloseAudit, dataDisposisi, dataPrimer, reloadList, isEdit, jenisIzin }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [listDokAudit, setListDokAudit] = useState([])
    const [hasilAuditDok, setHasilAuditDok] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!dataPrimer?.nomorAju || !dataDisposisi?.noTugas || dataDisposisi.idDisposisi !== 5) {
            return
        }
        try {
            const resHasilAudit = await pbumkuService.getUmkuAuditByAjuNoTugas(dataPrimer.nomorAju, dataDisposisi.noTugas)
            // console.log(resHasilAudit)
            if (resHasilAudit?.data) {
                setValueCatatan(resHasilAudit.data.catatan)
                setValueTglAudit(resHasilAudit.data.tglAudit)

                const resHasilAuditDok = await pbumkuService.listUmkuAuditDokByIdInspeksiAudit(resHasilAudit.data.idAudit)
                setHasilAuditDok(resHasilAuditDok.data.data)
            }
        } catch (error) {

        }
    }, [pbumkuService, dataDisposisi, dataPrimer])

    useEffect(() => {
        // console.log(dataPrimer)
        let isMounted = true;
        if (!dataPrimer) return;

        const loadData = async () => {
            try {
                const resDokAudit = await pbumkuService.listJenisDokByJenisIzinAndJenisDok(jenisIzin, 'aud', 0, 20)
                setListDokAudit(resDokAudit.data.data)

                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [pbumkuService, jenisIzin, dataPrimer, fetchAllData]);

    const [valueCatatan, setValueCatatan] = useState(null)
    const [valueTglAudit, setValueTglAudit] = useState(getCurrentDateFormatted())

    const onChangeTglAudit = e => {
        setValueTglAudit(e.target.value)
    }

    const onChangeCatatan = e => {
        // console.log(hasilAuditDok)
        setValueCatatan(e.target.value)
    }

    const handleChangeRadioSesuai = (id, value) => {
        setHasilAuditDok((prev) => {
            const existing = prev.find((item) => item.idJenisDok === id);
            if (existing) {
                return prev.map((item) =>
                    item.idJenisDok === id ? { ...item, isTersedia: value } : item
                );
            } else {
                return [...prev, { idJenisDok: id, keterangan: null, isTersedia: value }];
            }
        });
    }

    const handleChangeKeteranganSesuai = (id, value) => {
        setHasilAuditDok((prev) => {
            const existing = prev.find((item) => item.idJenisDok === id);
            if (existing) {
                return prev.map((item) =>
                    item.idJenisDok === id ? { ...item, keterangan: value } : item
                );
            } else {
                return [...prev, { idJenisDok: id, isTersedia: null, keterangan: value }];
            }
        });
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let noTugas = 'AUD-' + dataPrimer.nomorAju
            let jsonAudit = {
                nomorAju: dataPrimer.nomorAju,
                noTugas: noTugas,
                nipPetugas: localStorage.getItem('username'),
                nmPetugas: localStorage.getItem('nama'),
                catatan: valueCatatan,
                tglAudit: valueTglAudit,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }
            const resSaveAudit = await pbumkuService.saveUmkuAudit(jsonAudit)
            if (resSaveAudit.data.kode === '200') {
                //ev permohonan dok
                const idInspeksiAudit = resSaveAudit.data.id

                hasilAuditDok.map(async (auditDok) => {
                    let newAuditDok = {
                        ...auditDok,
                        idAudit: idInspeksiAudit,
                        nomorAju: dataPrimer.nomorAju,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date()
                    }
                    await pbumkuService.saveUmkuAuditDok(newAuditDok)
                })

                let dataDispo = {
                    ...dataDisposisi,
                    noTugas: noTugas,
                    tglTugas: new Date()
                }
                await pbumkuService.saveUmkuPenugasan(dataDispo)

                setShowConfirmProses(false)
                setShowProsesSuccess(true)
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickClose = () => {
        handleCloseAudit()
    }

    return (
        <>
            <Modal
                show={showAudit}
                onHide={handleCloseAudit}
                size='xl'
                centered
                scrollable
            >
                <Modal.Header>
                    <Modal.Title><h5>Audit Kecukupan (Desk Audit)</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPrimer?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Audit</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type='date' placeholder="Tanggal Audit" className="form-control-sm" value={valueTglAudit} onChange={onChangeTglAudit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <h6>Checklist Audit Kecukupan</h6>
                        </div>
                    </div>
                    {
                        listDokAudit &&
                        listDokAudit.map((dokwajib, idx) => {
                            const current = hasilAuditDok.find((h) => h.idJenisDok === dokwajib.idJenisDok)

                            return (
                                <>
                                    <div className='row' key={dokwajib.idJenisDok || idx}>
                                        <div className='col-12'>
                                            <Form>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">{dokwajib.uraianDok}</Form.Label>
                                                    <Col sm="4">
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input"
                                                                type="radio"
                                                                name={'inlineRadio' + dokwajib.idJenisDok}
                                                                id={'inlineRadio' + dokwajib.idJenisDok}
                                                                value="1"
                                                                checked={current?.isTersedia === "1"}
                                                                onChange={(e) => handleChangeRadioSesuai(dokwajib.idJenisDok, e.target.value)}
                                                            />
                                                            <label className="form-check-label" htmlFor={'inlineRadio' + dokwajib.idJenisDok}>Tersedia</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input"
                                                                type="radio"
                                                                name={'inlineRadio' + dokwajib.idJenisDok}
                                                                id={'inlineRadio' + dokwajib.idJenisDok}
                                                                value="0"
                                                                checked={current?.isTersedia === "0"}
                                                                onChange={(e) => handleChangeRadioSesuai(dokwajib.idJenisDok, e.target.value)}
                                                            />
                                                            <label className="form-check-label" htmlFor={'inlineRadio' + dokwajib.idJenisDok}>Tidak Tersedia</label>
                                                        </div>
                                                    </Col>
                                                    <Col sm="3">
                                                        <Form.Control type='text'
                                                            placeholder="keterangan"
                                                            className="form-control-sm"
                                                            onChange={(e) => handleChangeKeteranganSesuai(dokwajib.idJenisDok, e.target.value)}
                                                            value={current?.keterangan}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Form>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={onChangeCatatan} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses Audit Kecukupan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalAudit